module.exports = __webpack_public_path__ + "static/media/share-bottom@2x.5f2cd432.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/share-bottom@2x.png
// module id = 898
// module chunks = 0